if (!customElements.get('delivery-cutoff')) {
  customElements.define(
    'delivery-cutoff',
    class DeliveryCutoff extends HTMLElement {
      connectedCallback() {
        this.items = Array.from(this.querySelectorAll('.delivery-cutoff__item'));
        this.update();
      }

      update() {
        const now = new Date();
        const today = new Date(now.getFullYear(), now.getMonth(), now.getDate());

        this.items.forEach((item) => {
          const match = (item.dataset.date || '').match(/^(\d{4})-(\d{2})-(\d{2})$/);
          if (!match) return;

          const target = new Date(+match[1], +match[2] - 1, +match[3]);
          const days = Math.round((target - today) / 86400000);
          const status = item.querySelector('[data-status]');
          const bar = item.querySelector('[data-bar]');

          let state = 'open';
          let text = `${days} days left`;
          if (days < 0) {
            state = 'passed';
            text = 'Cut-off passed';
          } else if (days === 0) {
            state = 'soon';
            text = 'Last day';
          } else if (days <= 7) {
            state = 'soon';
            text = days === 1 ? '1 day left' : `${days} days left`;
          }

          item.dataset.state = state;
          status.textContent = text;
          status.hidden = false;
          // Bar fills as the deadline approaches (60-day window).
          const progress = state === 'passed' ? 100 : Math.max(4, Math.min(100, 100 - (days / 60) * 100));
          bar.style.width = `${progress}%`;
        });
      }
    }
  );
}
